<template>
  <div>
    <Row>
      <Col span="24">
      <Collapse size="large" v-model="value1">
        <Panel name="1" size="large" class="cpllapse-panel-title">
          涉税同名文件
          <div slot="content">
            <MyCloudList></MyCloudList>
          </div>
        </Panel>
      </Collapse>
      <Divider orientation="left" dashed>以下为搜索引擎</Divider>
      </Col>
    </Row>
    <SearchEngine></SearchEngine>
  </div>
</template>
<script>

import SearchMain from './../common/common_engine/search_main.vue'
import MainCloudList from './content_main_list.vue'

export default {
  name: "Identical_Content_Main",
  inject: ["reload"],
  data() {
    return {
      value1: ["1"],
      classid: "",
      pageType: "",
    }
  },
  provide() {
    return {
      expand: this.expand
    }
  },
  components: {
    'SearchEngine': SearchMain,
    'MyCloudList': MainCloudList,

  },
  methods: {
    expand() {
      this.vaule1 = ["1"];
      this.reload();

    },

  },
  mounted: function() {

  },
  watch: {

  }

}

</script>
<style scoped>
.cpllapse-panel-title {
  font-size: 12px;
}

.expand-row {
  margin-bottom: 16px;
}

</style>
